import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import ModalContainer from '../../../components/shared/modal/ModalContainer';
import { ModalTitle } from '../../../components/shared/modal/styled';
import { ButtonForm } from '../../../components/shared/formStyles.styled';
import { listWebhookEvents, getWebhookEvent } from '../../../services/integracao/webhooks';
import { handleSessionExpired } from '../../../utils/loginHelper';
import {
  ModalBodyPad,
  Table,
  StatusPill,
  EmptyState,
  EventsMeta,
  GhostButton,
  DetailGrid,
  DetailRow,
  JsonBlock,
  Toolbar,
} from './webhooks.styles';

const formatDate = (value) => {
  if (!value) return '—';
  try {
    return new Date(value).toLocaleString('pt-BR');
  } catch (e) {
    return value;
  }
};

const formatJson = (value) => {
  if (value === null || value === undefined) return 'null';
  if (typeof value === 'string') {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch (e) {
    return String(value);
  }
};

class WebhookEventsModal extends Component {
  state = {
    loading: false,
    events: [],
    meta: { total: 0, page: 1, last_page: 1, per_page: 15 },
    selected: null,
    loadingDetail: false,
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({ selected: null, loadingDetail: false }, () => this.fetchEvents(1));
    }

    if (prevProps.isOpen && !this.props.isOpen && this.state.selected) {
      this.setState({ selected: null, loadingDetail: false });
    }
  }

  getToken = () => this.props.login?.user?.token?.access_token || null;

  fetchEvents = async (page = 1) => {
    const token = this.getToken();
    if (!token) {
      toastr.error('Erro', 'Token de autenticação não encontrado.');
      return;
    }

    this.setState({ loading: true });
    try {
      const params = {
        page,
        per_page: this.state.meta.per_page || 15,
      };
      if (this.props.usersApiId) {
        params.users_api_id = this.props.usersApiId;
      }

      const response = await listWebhookEvents(token, params);
      if (response.status === 401) {
        this.setState({ loading: false });
        handleSessionExpired(this.props.dispatch);
        return;
      }

      this.setState({
        events: response.data?.data || [],
        meta: response.data?.meta || { total: 0, page: 1, last_page: 1 },
        loading: false,
      });
    } catch (error) {
      console.error(error);
      toastr.error('Erro', 'Não foi possível carregar os eventos.');
      this.setState({ loading: false, events: [] });
    }
  };

  openDetail = async (eventRow) => {
    const token = this.getToken();
    if (!token) return;

    this.setState({ loadingDetail: true, selected: { ...eventRow, _loading: true } });
    try {
      const response = await getWebhookEvent(token, eventRow.id);
      if (response.status === 401) {
        this.setState({ selected: null, loadingDetail: false });
        handleSessionExpired(this.props.dispatch);
        return;
      }
      if (response.status >= 200 && response.status < 300) {
        this.setState({ selected: response.data?.data || eventRow, loadingDetail: false });
        return;
      }
      toastr.error('Erro', 'Não foi possível carregar o detalhe do evento.');
      this.setState({ selected: null, loadingDetail: false });
    } catch (error) {
      console.error(error);
      toastr.error('Erro', 'Falha ao carregar detalhe do evento.');
      this.setState({ selected: null, loadingDetail: false });
    }
  };

  closeDetail = () => {
    this.setState({ selected: null, loadingDetail: false });
  };

  renderListFooter = () => {
    const { meta, loading } = this.state;

    return (
      <div style={{ display: 'flex', gap: 8, justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <GhostButton
            type="button"
            disabled={loading || (meta.page || 1) <= 1}
            onClick={() => this.fetchEvents((meta.page || 1) - 1)}
          >
            Anterior
          </GhostButton>
          <GhostButton
            type="button"
            disabled={loading || (meta.page || 1) >= (meta.last_page || 1)}
            onClick={() => this.fetchEvents((meta.page || 1) + 1)}
          >
            Próxima
          </GhostButton>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <GhostButton type="button" onClick={() => this.fetchEvents(meta.page || 1)} disabled={loading}>
            Atualizar
          </GhostButton>
          <ButtonForm type="button" onClick={this.props.onClose}>
            Fechar
          </ButtonForm>
        </div>
      </div>
    );
  };

  renderDetailFooter = () => (
    <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', width: '100%' }}>
      <ButtonForm type="button" onClick={this.closeDetail}>
        Fechar
      </ButtonForm>
    </div>
  );

  renderDetail = () => {
    const { selected, loadingDetail } = this.state;
    if (!selected) return null;

    if (loadingDetail || selected._loading) {
      return <EmptyState>Carregando detalhe...</EmptyState>;
    }

    return (
      <DetailGrid>
        <DetailRow>
          <strong>Evento</strong>
          <span>{selected.event_type}</span>
        </DetailRow>
        <DetailRow>
          <strong>Endpoint</strong>
          <span>{selected.endpoint}</span>
        </DetailRow>
        <DetailRow>
          <strong>Status</strong>
          <span>
            <StatusPill $ok={selected.status === 'ok'}>{selected.status}</StatusPill>
            {selected.status_code != null ? ` · HTTP ${selected.status_code}` : ''}
          </span>
        </DetailRow>
        <DetailRow>
          <strong>Latência</strong>
          <span>{selected.latency_ms != null ? `${selected.latency_ms} ms` : '—'}</span>
        </DetailRow>
        <DetailRow>
          <strong>Tentativa</strong>
          <span>{selected.attempt || 1}</span>
        </DetailRow>
        <DetailRow>
          <strong>Solicitação</strong>
          <span>{selected.solicitacao_id || '—'}</span>
        </DetailRow>
        <DetailRow>
          <strong>Pretendente</strong>
          <span>{selected.pretendente_id || '—'}</span>
        </DetailRow>
        <DetailRow>
          <strong>Data</strong>
          <span>{formatDate(selected.created_at)}</span>
        </DetailRow>
        {selected.error_message ? (
          <DetailRow>
            <strong>Erro</strong>
            <span>{selected.error_message}</span>
          </DetailRow>
        ) : null}
        <DetailRow>
          <strong>Request body</strong>
          <JsonBlock $tall>{formatJson(selected.request_body)}</JsonBlock>
        </DetailRow>
        <DetailRow>
          <strong>Response body</strong>
          <JsonBlock $tall>{formatJson(selected.response_body)}</JsonBlock>
        </DetailRow>
      </DetailGrid>
    );
  };

  renderList = () => {
    const { loading, events, meta } = this.state;

    if (loading) {
      return <EmptyState>Carregando eventos...</EmptyState>;
    }

    if (!events.length) {
      return <EmptyState>Nenhum evento encontrado.</EmptyState>;
    }

    return (
      <>
        <EventsMeta>
          <span>
            {meta.showing || events.length} de {meta.total || events.length} · página {meta.page || 1}/
            {meta.last_page || 1}
          </span>
        </EventsMeta>
        <Table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Evento</th>
              <th>Status</th>
              <th>HTTP</th>
              <th>Latência</th>
              <th>Solicitação</th>
              <th>Pretendente</th>
              <th>Data</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {events.map((event) => (
              <tr key={event.id}>
                <td>{event.id}</td>
                <td>{event.event_type}</td>
                <td>
                  <StatusPill $ok={event.status === 'ok'}>{event.status}</StatusPill>
                </td>
                <td>{event.status_code ?? '—'}</td>
                <td>{event.latency_ms != null ? `${event.latency_ms} ms` : '—'}</td>
                <td>{event.solicitacao_id || '—'}</td>
                <td>{event.pretendente_id || '—'}</td>
                <td>{formatDate(event.created_at)}</td>
                <td>
                  <GhostButton type="button" onClick={() => this.openDetail(event)}>
                    Ver detalhes
                  </GhostButton>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </>
    );
  };

  render() {
    const { isOpen, onClose } = this.props;
    const { selected } = this.state;

    return (
      <>
        <ModalContainer
          isOpen={isOpen}
          onClose={onClose}
          size="lg"
          customstyle={`
            @media (min-width: 992px) {
              &.modal-lg {
                max-width: 1120px;
              }
            }
          `}
          header={<ModalTitle>Eventos de WebHook</ModalTitle>}
          footer={this.renderListFooter()}
        >
          <ModalBodyPad>
            <Toolbar />
            {this.renderList()}
          </ModalBodyPad>
        </ModalContainer>

        <ModalContainer
          isOpen={Boolean(selected)}
          onClose={this.closeDetail}
          size="lg"
          zIndex={1060}
          customstyle={`
            .modal-content {
              min-height: 72vh;
            }
          `}
          header={<ModalTitle>{selected ? `Evento #${selected.id}` : 'Detalhes do evento'}</ModalTitle>}
          footer={this.renderDetailFooter()}
        >
          <ModalBodyPad $tall>{this.renderDetail()}</ModalBodyPad>
        </ModalContainer>
      </>
    );
  }
}

export default connect()(WebhookEventsModal);
